// extracted by mini-css-extract-plugin
export default {"container":"GetGuideURL_container__iZg4E","form":"GetGuideURL_form__HzMWq","newUrl":"GetGuideURL_newUrl__NV48t"};